import { getIdFromText } from 'utils/formatters';

const getHeadingElements = (contentWrapper: string): HTMLHeadingElement[] => {
  const wrapperElement = document.getElementById(contentWrapper);
  const headings = wrapperElement?.querySelectorAll('h2');
  if (!headings) return [];
  // Drop headings inside experiment-injected content (the above-fold CTA marks
  // its subtree with data-blog-toc-excluded) so they never become TOC entries.
  return Array.from(headings).filter(heading => !heading.closest('[data-blog-toc-excluded]'));
};

export const addIdsToHeadings = (contentWrapper: string) => {
  getHeadingElements(contentWrapper).forEach((heading, index) => {
    if (heading.id) {
      return;
    }
    heading.id = getIdFromText(heading.textContent || `heading-${index}`);
    // Add offset class to account for fixed header/navigation
    heading.classList.add('scroll-mt-[var(--height-nav)]');
  });
};

export const getHeadingDetails = (contentWrapper: string) =>
  getHeadingElements(contentWrapper).map(heading => ({
    label: heading.textContent,
    anchor: heading.id,
  }));
